import axios from '../index'

export default {
    getInstitucion () {
        return axios.get('/instituciones/usuario')
    },
    getInstitucionGestionUsuario () {
        return axios.get('/api/v1/instituciones/all')
    },
    getCiclosEscolares (institucionId) {
        return axios.get('/ciclos-escolares/ciclosPorInstitucion/'+ institucionId)
    },
    getGrupo(institucion, params){
        return axios.get('/grupos-administrativos/gruposInstitucion/' + institucion, {params})
    },
    getPrograma (institucionId) {
        return axios.get('/programas/institucion/'+ institucionId)
    },
    getRol (institucion_id) {
        return axios.get('/roles/institucion/' + institucion_id)
    },
    postCrearRol(datos){
        return axios.post('/roles/create', datos)
    },
    getInfoRoles(params){
        return axios.get('/roles/paginate', {params})
    },
    getValorCheck(formData){
        return axios.post('/roles/store', formData)
    },

    // GESTION DE USUARIOS 
    getGestionUsuarios(params){
        return axios.get('/permisos/paginate', {params})
    },
    postCrearAcceso(datos){
        return axios.post('/permisos/store', datos)
    },
    getMultiRoles(params){
        return axios.get('/roles/instituciones', {params})
    },
    postEditarAcceso(id, formData){
        return axios.post('/permisos/update/' + id, formData)
    },

    // FAMILIARES MASIVO 
    getFamiliaresMasivo(params){
        return axios.get('/vinculacionalumnos/getAlumnosFamiliares', {params})
    },
    getFamiliaresReferencia(params){
        return axios.get('/vinculacionalumnos/getFamiliaresSimsConHermanos', {params})
    },
    getFamiliaresReferencia(params){
        return axios.get('/vinculacionalumnos/getFamiliaresSimsConHermanos', {params})
    },
    getVincularFamiliar(params){
        return axios.get('/vinculacionalumnos/vincularFamiliaresSim', {params})
    },

    // ACCESO MASIVO A FAMILIARES 
    getAccesoMasivoFamiliares(params){
        return axios.get('/vinculacion-accesos/paginate', {params})
    },
    postUpdateAccesoFamiliar(idPersona, formData){
        return axios.post('/vinculacion-accesos/update/' + idPersona, formData)
    },
    postAccesosMasivosFamiliares(formData){
        return axios.post('/vinculacion-accesos/store', formData)
    },

    // ACCESO MASIVO A ALUMNOS 
    getAccesiMasivoAlumnos(params){
        return axios.get('/acceso-alumnos/paginate', {params})
    },
    postAccesosMasivosAlumnos(formData){
        return axios.post('/acceso-alumnos/store', formData)
    }
}